<script lang="ts">
	import { Link } from 'lucide-svelte';
	import Social from './Social.svelte';

	interface Props {
		title: string;
		href: string;
	}

	let { title, href }: Props = $props();

	let tooltip: HTMLDivElement | undefined = $state();

	function copyLink() {
		if (!tooltip) return;
		void navigator.clipboard.writeText(generateUtmLink('copy', false));
		tooltip.innerHTML = 'Copied';
	}

	function generateUtmLink(source: string, encode = true) {
		const url = new URL(href);

		const link = `${url.origin}${url.pathname}?utm_source=${source}&utm_medium=social`;
		return encode ? encodeURIComponent(link) : link;
	}
</script>

<div class="flex items-center gap-2">
	<Social
		platform="facebook"
		href={`https://www.facebook.com/sharer/sharer.php?u=${generateUtmLink('facebook')}`}
		size="small"
	/>
	<Social
		platform="twitter"
		href={`https://twitter.com/intent/tweet?url=${generateUtmLink(
			'twitter'
		)}&text=${encodeURIComponent(title)}`}
		size="small"
	/>
	<Social
		platform="telegram"
		href={`https://t.me/share/url?url=${generateUtmLink('telegram')}&text=${encodeURIComponent(
			title
		)}`}
		size="small"
	/>
	<Social
		platform="whatsapp"
		href={`https://api.whatsapp.com/send?text=${encodeURIComponent(title)}%20${generateUtmLink(
			'whatsapp'
		)}`}
		size="small"
	/>

	<button
		class="copy-link group relative"
		onclick={copyLink}
		onmouseleave={() => {
			if (tooltip) tooltip.innerHTML = 'Copy URL';
		}}
		aria-label="Copy URL"
	>
		<Link class="text-white-pure w-3" />
		<div class="tooltip" bind:this={tooltip}>Copy URL</div>
	</button>
</div>

<style lang="postcss">
	@reference '../app.css';

	.copy-link {
		@apply bg-gray-dark inline-flex aspect-square h-6 w-6 items-center justify-center rounded-full text-center hover:opacity-90;
	}

	.tooltip {
		@apply bg-gray-dark text-white-pure absolute -bottom-10 -left-5 hidden w-20 rounded-lg p-2 text-center text-xs group-hover:block;

		&:before {
			content: '';
			@apply bg-gray-dark absolute top-0 right-0 left-0 -z-10 mx-auto h-4 w-4 rotate-45;
		}
	}
</style>
